import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { OFFICIAL_SUPPORT_URL } from '../data/faqs';
import './Footer.css';

const SocialIcon = ({ href, label, children }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="social-link"
    aria-label={label}
  >
    {children}
  </a>
);

export default function Footer() {
  const navigate = useNavigate();

  const handleNavClick = (path, sectionId) => {
    if (sectionId) {
      if (window.location.pathname !== '/') {
        navigate(`/#${sectionId}`);
      } else {
        const el = document.getElementById(sectionId);
        if (el) {
          const promoEl = document.querySelector('.promo-banner, .announcement-bar');
          const promoH = promoEl ? Math.ceil(promoEl.getBoundingClientRect().height) : 0;
          const offset = promoH + 80 + 20;
          const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition, offset,
            behavior: 'smooth'
          });
        }
      }
    } else {
      if (window.location.pathname === path) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        navigate(path);
      }
    }
  };

  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-grid">
          {/* Brand Col */}
          <div className="footer-col brand-col">
            <Link to="/" onClick={() => handleNavClick('/')}>
              <img src="/logo.webp" alt="iLOVEthisgame Canada, Official Playermaker Partner Logo" className="footer-logo-img" width="180" height="40" loading="lazy" />
            </Link>
            <p className="footer-tagline">
              Official Canadian partner and authorized distributor of Playermaker smart soccer wearable technology.
            </p>

            {/* Social Icons */}
            <div className="footer-socials">
              <SocialIcon href="https://www.facebook.com/profile.php?id=61576233443659" label="Facebook">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </SocialIcon>

              <SocialIcon href="https://instagram.com/ilovethisgame.ca" label="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
                </svg>
              </SocialIcon>

              <SocialIcon href="https://www.youtube.com/@iLOVEthisGAME_ca" label="YouTube">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
                  <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#060608"/>
                </svg>
              </SocialIcon>

              <SocialIcon href="https://tiktok.com/@ilovethisgame.ca" label="TikTok">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.32 6.32 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.25 8.25 0 0 0 4.83 1.56V6.78a4.86 4.86 0 0 1-1.06-.09z"/>
                </svg>
              </SocialIcon>

              <SocialIcon href="https://www.linkedin.com/company/ilovethisgame" label="LinkedIn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                  <rect x="2" y="9" width="4" height="12"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              </SocialIcon>
            </div>

            <p className="footer-copy">
              &copy; {new Date().getFullYear()} iLOVEthisgame.ca. All rights reserved.
            </p>
          </div>

          {/* Products & Support Col */}
          <div className="footer-col">
            <h4 className="footer-title">HELP &amp; SUPPORT</h4>
            <ul className="footer-links">
              <li><Link to="/about" onClick={() => handleNavClick('/about')}>About Us</Link></li>
              <li><Link to="/admin" onClick={() => handleNavClick('/admin')}>Admin System Console</Link></li>
              <li><Link to="/contact" onClick={() => handleNavClick('/contact')}>Contact Us</Link></li>
              <li><Link to="/faq" onClick={() => handleNavClick('/faq')}>Full FAQ Center</Link></li>
              <li><Link to="/#product-showcase" onClick={() => handleNavClick('/', 'product-showcase')}>Playermaker 2.0 Kit</Link></li>
              <li><a href={OFFICIAL_SUPPORT_URL} target="_blank" rel="noopener noreferrer">Playermaker Official Support</a></li>
              <li><Link to="/privacy-policy" onClick={() => handleNavClick('/privacy-policy')}>Privacy Policy</Link></li>
              <li><Link to="/#color-straps" onClick={() => handleNavClick('/', 'color-straps')}>Replacement Straps</Link></li>
              <li><Link to="/terms-of-service" onClick={() => handleNavClick('/terms-of-service')}>Terms of Service</Link></li>
            </ul>
          </div>

          {/* Technology & Insights Col */}
          <div className="footer-col">
            <h4 className="footer-title">INSIGHTS &amp; TECH</h4>
            <ul className="footer-links">
              <li><Link to="/#specs" onClick={() => handleNavClick('/', 'specs')}>Device Blueprint</Link></li>
              <li><Link to="/blog" onClick={() => handleNavClick('/blog')}>Performance Blog Hub</Link></li>
              <li><Link to="/#how-it-works" onClick={() => handleNavClick('/', 'how-it-works')}>Stats &amp; Telemetry</Link></li>
              <li><Link to="/#features" onClick={() => handleNavClick('/', 'features')}>Technology Overview</Link></li>
            </ul>
          </div>

          {/* Newsletter Col */}
          <div className="footer-col newsletter-col">
            <h4 className="footer-title">JOIN THE ACADEMY</h4>
            <p className="newsletter-text">
              Subscribe to <strong>iLOVEthisGAME</strong> and get training drill guides, insights and metrics analysis.
            </p>
            <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
              <input type="email" placeholder="Your email address" className="newsletter-input" required />
              <button type="submit" className="btn btn-volt newsletter-btn">Join</button>
            </form>
          </div>
        </div>
      </div>
    </footer>
  );
}
